/* ================================================== */
/* CONTROLLER → Form
/* ================================================== */

var resultsStepIndex, neighborhood;

app.controller('formCtrl', ['$rootScope', '$scope', '$http', '$timeout', function($rootScope, $scope, $http, $timeout) {

	// Init
	$rootScope.lang           = $('html').attr('lang');

	$rootScope.formDataRaw    = {};
	$rootScope.formDataCooked = {};

	$scope.step               = 0;
	$scope.lastStep           = 1;
	$scope.timelineOffset     = 0;
	$scope.results            = null;
	$scope.oldResult          = null;

	lastStepIndex             = $('.step--last:not(.step--result)').index(),
	resultsStepIndex          = $('.step--result').index(),
	endTimelineReached        = false;


	/* ================================================== */
	/* CONTROLLER → Form → utilities
	/* ================================================== */

	// Is object?
	$scope.isObject = function(value) {
		return angular.isObject(value);
	}

	$.get('https://ipinfo.io', function(response) {
		$scope.ip = response;
	}, 'jsonp');


	/* ================================================== */
	/* CONTROLLER → Form → step
	/* ================================================== */

	// Go to step
	$rootScope.goToStep = function(step, next, reset) {

		// Cook data
		$scope.cookData();

		// Update form
		if (step <= $scope.lastStep || next === true) {

			// Update step
			$scope.updateStep(step);

			// Reset data
			$scope.resetData((step == 1 && reset == true) ? true : false);

			// Options restriction
			$scope.optionsRestriction('numberOfRooms');

		}

		// Reset results
		if (step === resultsStepIndex) {
			$scope.results = null;
		}

		// Send step ID to Google Analytics
		if (typeof ga !== 'undefined') {
			var stepId = $('[data-step-index="' + step + '"]').data('step-id');
			ga('send', 'pageview', '/form/step-' + stepId);
		}

		// Next step transition
		$scope.nextStepTransition();

	};

	$scope.updateStep = function(step) {
		$scope.step     = step;
		$scope.lastStep = (step > $scope.lastStep) ? step : $scope.lastStep;

		// From first step of last steps of the form
		if ($scope.step >= lastStepIndex) {

			var lastIteration = false;

			// → 😢 animate callback not working anymore
			// $('.step--location.ng-hide').on('$animate:close', function(data) { });

			// → 😅 replaced by setTimeout + CSS transition
			function reinitMap() {

				// Resize map
				if (mapboxglSupported) {
					map.resize();
				} else {
					map.invalidateSize();
				}

				// Reset map center
				if ($scope.lastStep == lastStepIndex) {
					mapHeight();
				}

				// Show map
				if ($scope.step === lastStepIndex && lastIteration === true) {
					$('.step--map').addClass('step--map--visible');
				}

			}

			for (var i = 0; i < 5; i++) {
				$timeout(function() { reinitMap() }, 50 * i);
				if (i === 4) lastIteration = true;
			}

		}

		// Last step of the form trigger
		if ($scope.lastStep == resultsStepIndex) {

			// Send results
			$scope.getResults();

			// Resize carousel
			$('.step--location.ng-hide').on('$animate:close', function(data) {
				if ($carousel.length && isFlickity === true) {
					$carousel.flickity('resize');
				}
			});

		}
	}

	// Reset to first step
	$rootScope.resetToFirstStep = function() {

		if (typeof mapLoaded !== 'undefined' && mapLoaded === true) {

			// Reset data
			$scope.resetData(true);

			// Reset results
			$scope.results = null;

			// Go to first step
			$scope.goToStep(1);

			// Close menu
			closeMenu();

		} else {

			// Re-call function
			$timeout(function() { $rootScope.resetToFirstStep() }, 250);

		}

	}

	// Next step transition
	$scope.nextStepTransition = function() {

		// Auto-scroll timeline to current step
		if ((breakpointXs || breakpointXxs)
			&& $scope.step >= 2 && $scope.lastStep <= resultsStepIndex && endTimelineReached === false) {

			// Disable auto-scroll when last step is reached
			if ($scope.lastStep == resultsStepIndex) {
				endTimelineReached = true;
			}

			// Auto-scroll after step transition delay
			setTimeout(function(){

				// From step 5 → special steps (multi & map)
				var eq = ($scope.step >= 5) ? 5 : $scope.step - 2;

				// Get scroll offset from list items widths
				$scope.timelineOffset = $scope.timelineOffset + $('.timeline li').eq(eq).outerWidth();

				// Scroll w/ animate
				$('.timeline').animate({ scrollLeft: $scope.timelineOffset }, 300);

			}, 600);
		}

		// Mobile
		if (breakpointXxs) {
			// Reset scroll
			$('html, body').animate({ scrollTop: 0 }, 300);
		}

	}


	/* ================================================== */
	/* CONTROLLER → Form → data
	/* ================================================== */

	// Cook data
	$scope.cookData = function() {
		if (typeof $rootScope.formDataRaw !== 'undefined') {
			angular.forEach($rootScope.formDataRaw, function(value, key) {

				// If possible, convert raw string to raw int 
				if ($scope.isObject(value)) {
					angular.forEach(value, function(childValue, childKey) {
						var value = parseInt($rootScope.formDataRaw[key][childKey], 10);
						$rootScope.formDataRaw[key][childKey] = (isNaN(value) === true) ? $rootScope.formDataRaw[key][childKey] : value;
					});
				} else {
					var intValue = parseInt($rootScope.formDataRaw[key], 10);
					$rootScope.formDataRaw[key] = (isNaN(intValue) === true) ? $rootScope.formDataRaw[key] : intValue;
				}

				// Set neighborhood instead of address
				if (key == 'location') {
					if ($rootScope.hasGq($rootScope.formDataRaw.neighborhoodId) === true) {
						$rootScope.formDataCooked.location = neighborhood;
					}

				// Cook data for timeline & summary
				} else {

					// Init
					var $modelAttrValue = $('[data-ng-model="formDataRaw.' + key +'"][value="' + value + '"]'),
						$modelVal       = $('[data-ng-model="formDataRaw.' + key +'"]').val();

					// Assign raw data to cook data → if object
					if ($scope.isObject(value) === true) {
						$rootScope.formDataCooked[key] = value;

					// → If regular input
					} else if ($modelAttrValue.length > 0) {
						$rootScope.formDataCooked[key] = $modelAttrValue.data('option');

					// → If select input
					} else if ($modelVal !== null) {
						$rootScope.formDataCooked[key] = $modelVal;
					}

					// Add unit to number data
					var $unit = $('.step--' + (key) + ' .unit');
					if (value === parseInt(value, 10) && $unit.length) {
						$rootScope.formDataCooked[key] = value + ' ' + $unit.html();
					}

				}

			});
		}
	}

	// Reset data
	$scope.resetData = function(reset) {
		if (typeof reset !== 'undefined' && reset === true) {

			// Sets the form to its initial state
			$scope.testForm.$setPristine(true);

			$rootScope.formDataRaw    = {};
			$rootScope.formDataCooked = {};

			$scope.step     = 1;
			$scope.lastStep = 1;

			$rootScope.resetAutocomplete();

			// Reset default coordinates & zoom level, remove active neighborhood
			if (mapboxglSupported) {
				map.flyTo({ center: [defaultPointX, defaultPointY], zoom: defaultZoom })
				   .setLayoutProperty('neighborhoods-fills-active', 'visibility', 'none');
			} else {

				map.setView([defaultPointX, defaultPointY], defaultZoom)

				neighborhoodLayer.eachLayer(function(layer) {
					if (layer == selected) {
						return neighborhoodLayer.resetStyle(layer);
					}
				});

			}

		}
	}

	// Options restriction
	$scope.optionsRestriction = function(name) {
		if (typeof name !== 'undefined') {

			// Number of rooms
			if (name == 'numberOfRooms') {
				var $stepNumberOfRooms = $('.step--numberOfRooms');
				if ($('.step--numberOfRooms').length > 0) {
					var $modelNumberOfRooms           = $('[data-ng-model="formDataRaw.numberOfRooms"]', $stepNumberOfRooms),
						$stepNumberOfRoomsFirstInput  = $modelNumberOfRooms.eq(0),
						$stepNumberOfRoomsOtherInputs = $modelNumberOfRooms.not(':eq(0)');

					if ($rootScope.formDataRaw.housingType == 'studio') {
						$rootScope.formDataRaw.numberOfRooms = $stepNumberOfRoomsFirstInput.val();
						$stepNumberOfRoomsOtherInputs.attr('disabled', true);
					} else {
						$stepNumberOfRoomsOtherInputs.attr('disabled', false);
					}
				}
			}

		}
	}


	/* ================================================== */
	/* CONTROLLER → Form → result
	/* ================================================== */

	function resultWrapperMinHeight() {
		$('.result__wrapper').css('min-height', $('.result__wrapper').height());
	}

	$(window).on('resize orientationchange', function(){
		resultWrapperMinHeight();
	});

	$scope.getResults = function() {
		// Init data
		var transform = function(data){
			return $.param(data);
		}

		var configs = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			},
			transformRequest: transform
		};

		$rootScope.formDataRaw[csrfTokenName] = csrfTokenValue;

		// Get data
		$http.post('/actions/utilities-module/results', $rootScope.formDataRaw, configs)
			 .then(function successCallback(response) {
				$scope.results = response.data;

				// Check if prices are different than previously
				if (!angular.equals($scope.results, $scope.resultsOld)) {
					$scope.saveResults();
				}
				$scope.resultsOld = $scope.results;

				// Set wrapper min. height
				setTimeout(function(){
					resultWrapperMinHeight();
				}, 600);
			}, function errorCallback(response) {
				$scope.results = null;
				if ($scope.results !== null) {
					$scope.results = null;
				}
			}
		);

	}

	$scope.saveResults = function() {

		if ($rootScope.hasGq($rootScope.formDataRaw.neighborhoodId) === true) {

			// Init
			var postUrl  = 'sprout-forms/entries/save-entry',
				formData = {
				action: postUrl,
				handle: 'test',
				fields: {}
			};

			// Prepare value
			function capitalizeFirstLetter(string) {
				return string.charAt(0).toUpperCase() + string.slice(1);
			}

			function prepareValue(value){
				value = (typeof value === 'string') ? capitalizeFirstLetter(value) : value;
				value = (typeof value === 'string') ? value.replace('-', ' ') : value;
				return value;
			}

			// Prepare array of data
			angular.forEach($rootScope.formDataRaw, function(value, key) {
				if (typeof $rootScope.formDataRaw[key] !== 'object') {
					if (value === true) {
						formData['fields[' + key + ']'] = 1;
					} else if (value === false) {
						formData['fields[' + key + ']'] = 0;
					} else {
						formData['fields[' + key + ']'] = prepareValue(value);
					}
				} else {
					angular.forEach($rootScope.formDataRaw[key], function(childValue, childKey) {
						formData['fields[' + childKey + ']'] = childValue;
					});
				}
			});

			// Add neighborhood
			formData['fields[neighborhood]'] = $rootScope.formDataCooked.location;
			formData['fields[sector]']       = $rootScope.formDataRaw.gq.toString().replace('{{', '').replace('}}', '');
			formData['fields[index]']        = $scope.results.index;

			// Add prices
			formData['fields[price]']    = $scope.results.price;
			formData['fields[minPrice]'] = $scope.results.minPrice;
			formData['fields[maxPrice]'] = $scope.results.maxPrice;

			// Add IP
			formData['fields[ipRange]']   = $scope.ip.ip;
			formData['fields[ipCountry]'] = $scope.ip.country;
			formData['fields[ipRegion]']  = $scope.ip.region;
			formData['fields[ipCity]']    = $scope.ip.city;

			// Add CSRF
			formData[csrfTokenName] = csrfTokenValue;
			delete formData['fields[' + csrfTokenName + ']'];

			console.log(formData);

			// Serialize data
			formData = $.param(formData);

			// Save data 
			// → jQuery AJAX is recommended (following Sprout Forms' documentation)
			$.ajax({
				type    : 'POST',
				url     : postUrl,
				data    : formData,
				dataType: 'json',
				encode  : true
			});
			// .done(function(data) {
			// 	console.log(data);
			// });

		}

	}


	/* ================================================== */
	/* CONTROLLER → Form → hash in URL to step
	/* ================================================== */

	if (window.location.hash === '#step-1') {
		$scope.goToStep(1);
	}


	/* ================================================== */
	/* CONTROLLER → Various
	/* ================================================== */

	// Trigger click
	$rootScope.triggerClick = function($element) {
		$element.click();
	}


}]);